import React, { useEffect, useState } from 'react';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Checkbox,
    FormControlLabel,
    Box,
    Grid
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import WSSCheckBoxField from '../CheckBox/WSCheckBox';
import { Control } from 'react-hook-form';

interface TreeViewFieldProps {
    permissions: IPermission[];
    disabled?: boolean;
    onCheckedChange?: (data: any) => void;
    control: Control;
    setValue: any;
    getValues: any
}

export interface IPermission {
    selectAll?: boolean;
    module: string;
    page: string;
    actions: IActions[];
}

interface IActions {
    label: string;
    operation: string;
    permission: boolean;
}

const WSTreeViewField: React.FC<TreeViewFieldProps> = ({ permissions, disabled, onCheckedChange, control, setValue, getValues }) => {
    const [checked, setChecked] = useState<Record<string, boolean>>({});
    const [expanded, setExpanded] = useState<string | false>(false);

    const handleCheck = (key: string) => {
        const newChecked = {
            ...checked,
            [key]: !checked[key]
        };
        setChecked(newChecked);
        onCheckedChange?.(newChecked);
    };
    useEffect(()=>{
        permissions?.map((mod:any)=>{
            const ind=mod.actions.findIndex((act:IActions)=>act.permission===false)
            if(mod.actions.findIndex((act:IActions)=>act.permission===false)===-1){
                setValue(mod.page, true);
            }
            mod.actions.forEach((action: IActions) => {
                const key = `${mod.page}-${action.operation}`;
                setValue(key, action.permission);
             
            });
        })
    },[])
    const handleAccordionToggle = (panel: string) => (_: React.SyntheticEvent, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };
    const handleCheckAll = (mod: IPermission, checked: boolean) => {

        setValue(mod.page, checked);

        // Set all child permissions
        mod.actions.forEach((action: any) => {
            const key = `${mod.page}-${action.operation}`;
            setValue(key, checked);
        });
        if (onCheckedChange) {
            onCheckedChange(buildUpdatedPermissions());
        }
    };
    const handleCheckChild = (mod: IPermission, checked: boolean, keyId: string) => {
        // Set the changed checkbox
        setValue(keyId, checked);

        // Check if all child checkboxes are checked (using form values)
        const allChecked = mod.actions.every((action) => {
            const key = `${mod.page}-${action.operation}`;
            return getValues(key) === true;
        });

        // Update the parent checkbox based on child state
        setValue(mod.page, allChecked);
        if (onCheckedChange) {
            onCheckedChange(buildUpdatedPermissions());
        }
    };
    const buildUpdatedPermissions = (): IPermission[] => {
        return permissions.map((mod) => ({
            ...mod,
            actions: mod.actions.map((action) => {
                const key = `${mod.page}-${action.operation}`;
                return {
                    ...action,
                    permission: getValues(key) || false,
                };
            }),
            selectAll: getValues(mod.module) || false,
        }));
    };

    return (
        <Box>
            {permissions.map((mod, i) => {
                const panelId = `${mod.module}-${i}`;
                const isPanelExpanded = expanded === panelId;

                return (
                    <Accordion
                        key={panelId}
                        expanded={isPanelExpanded}
                        onChange={handleAccordionToggle(panelId)}
                    >
                        <Grid item container spacing={1} alignItems="center">
                            <Grid item sm={0.5}>
                                <AccordionSummary expandIcon={isPanelExpanded ? <RemoveIcon /> : <AddIcon />}>
                                </AccordionSummary>
                            </Grid>
                            <Grid item sm={0.3}>
                                <WSSCheckBoxField
                                    isTickIcon={true}
                                    setValue={setValue}
                                    rules={{ required: false }}
                                    control={control}
                                    onChange={(e: any) => handleCheckAll(mod, e.target.checked)}
                                    id={mod.page}
                                    name={mod.page}
                                />
                            </Grid>
                            <Grid item sm={0.5}>

                                <Typography variant="body2">{mod.page}</Typography>

                            </Grid>
                        </Grid>

                        <AccordionDetails sx={{ mt: -2 }}>
                            {mod.actions.map((action, j) => {
                                const key = `${mod.page}-${action.operation}`;
                                return (
                                    <Box key={key} sx={{ mb: 0, }}>
                                        <WSSCheckBoxField
                                            isTickIcon={true}
                                            setValue={setValue}
                                            sx={{ ml: 6 }}
                                            rules={{ required: false }}
                                            control={control}
                                            id={key}
                                            onChange={(e: any) => handleCheckChild(mod, e.target.checked, key)}
                                            name={key}
                                            label={action.label}
                                        />
                                    </Box>
                                );
                            })}
                        </AccordionDetails>
                    </Accordion>
                );
            })}
        </Box>
    );
};

export default WSTreeViewField;
